<template>
  <div class="pwc-event-qrcode">
    <van-nav-bar
      :title="cTitle"
      left-arrow
      fixed
      @click-left="handleReturn"
    />
    <pwc-container>
      <div class="pwc-qrcode-list">
        <code-item
          v-for="e in cApprovedEvents"
          :key="e.id"
          :event="e"
          class="pwc-qrcode-item"
        />
      </div>
      <pwc-no-data v-if="cApprovedEvents.length === 0" />
    </pwc-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import RouterName from '@/constants/route'
import Actions from '@/constants/action'
import { loading } from '@/mixin'
import CodeItem from './CodeItem'
import { NavBar } from 'vant'
import PwcContainer from '@/views/layout/mobile/PwcContainer'
import PwcNoData from '@/components/NoData'

export default {
  components: {
    VanNavBar: NavBar,
    PwcNoData,
    PwcContainer,
    CodeItem
  },
  mixins: [loading],
  data() {
    return {
      approvedEvents: []
    }
  },
  computed: {
    ...mapState(['loading']),
    cLoading() {
      return this.loading.approvedEventLoading
    },
    cTitle() {
      return `签到二维码`
    },
    cApprovedEvents() {
      // reshap for 2 column
      const leftIndex = []
      const rightIndex = []
      const rowCount = Math.ceil(this.approvedEvents.length / 2)
      for (let i = 0; i < rowCount; i++) {
        leftIndex.push(i * 2)
        rightIndex.push(2 * i + 1)
      }

      const finalIndex = leftIndex.concat(...rightIndex)
      const finalList = []
      for (let i = 0; i < finalIndex.length; i++) {
        if (finalIndex[i] < this.approvedEvents.length) {
          finalList.push(this.approvedEvents[finalIndex[i]])
        }
      }

      return finalList
    }
  },
  created() {
    this.getqrcodeEvents()
      .then((d) => {
        this.approvedEvents = d
      })
  },
  methods: {
    ...mapActions({
      getqrcodeEvents: Actions.GET_APPROVED_EVENTS
    }),
    handleReturn() {
      this.$router.replace({
        name: RouterName.home,
        query: {
          active: 'self'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-qrcode-list {
  columns: 2;
  column-gap: 2px;

  .pwc-qrcode-item {
      box-sizing: border-box;
      break-inside: avoid;
      padding: 2px;
  }
}
</style>
